// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

/* eslint no-unused-vars: 0 */
/* eslint no-undef: 0 */
(function (mod) {
  // if (typeof exports == "object" && typeof module == "object") // CommonJS
  mod(require("codemirror"));
  // else if (typeof define == "function" && define.amd) // AMD
  // define(["codemirror"], mod);
  // else // Plain browser env
  // mod(CodeMirror);
})(function (CodeMirror) {
  "use strict";

  CodeMirror.defineMode("abc", function (config, parserConfig) {
    var words = {};
    function define(style, dict) {
      for (var i = 0; i < dict.length; i++) {
        words[dict[i]] = style;
      }
    }

    var repeat = ["|]", "[|", "|:", ":|", "::", "||", "|"];
    var pitch = "zZcdefgabCDEFGAB";
    var pitch_reg = new RegExp("^[" + pitch + "]+");
    var harmony_reg = new RegExp("\\[\\]");
    var comment_reg = new RegExp("%%");

    var commonAtoms = ["true", "false"];
    function tokenBase(stream, state) {
      var sol = stream.sol();
      var ch = stream.next();
      if (sol) {
        if (ch === "%" && stream.peek() === "%") {
          //コメント
          stream.skipToEnd();
          return "link";
        }
      }
      if (ch.match(pitch_reg)) {
        // 音程
        return "string";
      }

      if (ch.match(/\[/) || ch.match(/\]/)) {
        return "tag";
      }
      if (ch == "|") {
        return "tag";
      }
    }

    function tokenize(stream, state) {
      return (state.tokens[0] || tokenBase)(stream, state);
    }

    return {
      startState: function () {
        return { tokens: [] };
      },
      token: function (stream, state) {
        return tokenize(stream, state);
      },
      closeBrackets: "()[]{}''\"\"``",
      lineComment: "#",
      fold: "brace",
    };
  });

  CodeMirror.defineMIME("text/x-abc", "abc");
  // Apache uses a slightly different Media Type for Shell scripts
  // http://svn.apache.org/repos/asf/httpd/httpd/trunk/docs/conf/mime.types
  // CodeMirror.defineMIME('application/x-sh', 'shell');
});
